import { render, staticRenderFns } from "./Comissoes.vue?vue&type=template&id=b34dcc62&scoped=true"
import script from "./Comissoes.vue?vue&type=script&lang=js"
export * from "./Comissoes.vue?vue&type=script&lang=js"
import style0 from "./Comissoes.vue?vue&type=style&index=0&id=b34dcc62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34dcc62",
  null
  
)

export default component.exports